import { Routes, Route } from 'react-router-dom'
import { AuthGuard } from './features/auth/AuthGuard'

// Public pages
import HomePage from './pages/public/HomePage'

// Auth pages
import LoginPage from './pages/auth/LoginPage'
import SignupPage from './pages/auth/SignupPage'

// Dashboard pages
import DashboardPage from './pages/dashboard/DashboardPage'
import ExpensesPage from './pages/dashboard/ExpensesPage'
import FinancialsPage from './pages/dashboard/FinancialsPage'
import TeamPage from './pages/dashboard/TeamPage'
import MeetingsPage from './pages/dashboard/MeetingsPage'
import DocsPage from './pages/dashboard/DocsPage'
import BusinessPage from './pages/dashboard/BusinessPage'
import SubscriptionsPage from './pages/dashboard/SubscriptionsPage'
import TodosPage from './pages/dashboard/TodosPage'
import ReportsPage from './pages/dashboard/ReportsPage'
import UsersPage from './pages/dashboard/UsersPage'
import InvoicesPage from './pages/dashboard/InvoicesPage'
import SettingsPage from './pages/dashboard/SettingsPage'
import ProfilePage from './pages/dashboard/ProfilePage'
import MissionControlPage from './pages/dashboard/MissionControlPage'

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />

      {/* Auth routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />

      {/* Protected dashboard routes */}
      <Route path="/dashboard" element={
        <AuthGuard>
          <DashboardPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/expenses" element={
        <AuthGuard>
          <ExpensesPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/financials" element={
        <AuthGuard>
          <FinancialsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/team" element={
        <AuthGuard>
          <TeamPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/meetings" element={
        <AuthGuard>
          <MeetingsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/docs" element={
        <AuthGuard>
          <DocsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/business/:id" element={
        <AuthGuard>
          <BusinessPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/subscriptions" element={
        <AuthGuard>
          <SubscriptionsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/todos" element={
        <AuthGuard>
          <TodosPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/reports" element={
        <AuthGuard>
          <ReportsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/invoices" element={
        <AuthGuard>
          <InvoicesPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/users" element={
        <AuthGuard requireAdmin>
          <UsersPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/settings" element={
        <AuthGuard>
          <SettingsPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/mission-control" element={
        <AuthGuard>
          <MissionControlPage />
        </AuthGuard>
      } />
      <Route path="/dashboard/profile" element={
        <AuthGuard>
          <ProfilePage />
        </AuthGuard>
      } />
    </Routes>
  )
}

export default App
